import React from 'react';

const CustomerDetails = ({ details }) => (
  <div className="pt-4 pr-4 pl-4 max-w-[700px] ">
    <div className="flex flex-col sm:flex-row justify-between mb-2">
      <p><strong>Name:</strong> {details.name}</p>
      <p className="sm:ml-4 sm:mr-48 mt-2 sm:mt-0"><strong>Phone:</strong> {details.phone}</p>
    </div>

    <div className="flex flex-col sm:flex-row justify-between">
      <p className="flex-1 mb-2 sm:mb-0"><strong>Email:</strong> {details.email}</p>
      <p className="flex-1 mb-2 mr-14 sm:mb-0"><strong>Address:</strong> {details.address}</p>
    </div>
  </div>
);

export default CustomerDetails;
